// noinspection NonAsciiCharacters

// eslint-disable-next-line import/prefer-default-export
export enum RussianDayOfTheWeek {
  Воскресенье = 0,
  Понедельник = 1,
  Вторник = 2,
  Среда = 3,
  Четверг = 4,
  Пятница = 5,
  Суббота = 6,
}
